/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react plugin used to create google maps
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} from "react-google-maps";

// reactstrap components
import {Card, Container, Row} from "reactstrap";
// core components
// mapTypeId={google.maps.MapTypeId.ROADMAP}

const MapWrapper = withScriptjs(
    withGoogleMap(props => (
        <GoogleMap
            defaultZoom={4}
            defaultCenter={{lat: 41.4073652, lng: 2.2011561}}
            defaultOptions={{
                scrollwheel: true,
                styles: [
                    {
                        featureType: "administrative",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#444444"}]
                    },
                    {
                        featureType: "landscape",
                        elementType: "all",
                        stylers: [{color: "#f2f2f2"}]
                    },
                    {
                        featureType: "poi",
                        elementType: "all",
                        stylers: [{visibility: "off"}]
                    },
                    {
                        featureType: "road",
                        elementType: "all",
                        stylers: [{saturation: -100}, {lightness: 45}]
                    },
                    {
                        featureType: "road.highway",
                        elementType: "all",
                        stylers: [{visibility: "simplified"}]
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.icon",
                        stylers: [{visibility: "off"}]
                    },
                    {
                        featureType: "transit",
                        elementType: "all",
                        stylers: [{visibility: "off"}]
                    },
                    {
                        featureType: "water",
                        elementType: "all",
                        stylers: [{color: "#5e72e4"}, {visibility: "on"}]
                    }
                ]
            }}
        >
            {props.markers.map((marker, index) => (
                marker
            ))}
            {/*<Marker position={{lat: 41.4073652, lng: 2.2011561}}/>*/}
        </GoogleMap>
    ))
);

class Maps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            markers: this.makeMarkers(props.coordinates),
        };
    }

    render() {
        return (
            <>
                {/* Page content */}
                <Container className="m-2" fluid>
                    <Row>
                        <div className="col">
                            <Card className="shadow border-0">
                                <MapWrapper
                                    markers={this.state.markers}
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCjeKES7DKa-uca1NIUSyE87x7xCKeAJGg"
                                    loadingElement={<div style={{height: `100%`}}/>}
                                    containerElement={
                                        <div
                                            style={{height: `900px`}}
                                            className="map-canvas"
                                            id="map-canvas"
                                        />
                                    }
                                    mapElement={
                                        <div style={{height: `100%`, borderRadius: "inherit"}}/>
                                    }
                                />
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    makeMarkers(coordinates) {
        return coordinates.map((c, index) => {
            let coords = null
            try {
                coords = c.coordinates ? c.coordinates.split(',') : []
            } catch (e) {
                console.log(c)
            }
            console.log(`--------------- COORDS: ${coords}`)
            if (coords && coords.length == 2) {
                return <Marker
                    key={index}
                    // icon={{url: c.logo, scaledSize: new window.google.maps.Size(90, 42)}}
                    position={{lat: parseFloat(coords[0]), lng: parseFloat(coords[1])}}/>
            } else {
                return null
            }
        })
    }
}

export default Maps;
